module.exports = __webpack_public_path__ + "static/img/data_dashboard.ed6d13f9.jpg";